const firebaseDev = {
  apiKey: 'AIzaSyB6oWgMANIKX_c7TPzqfT18g7HzurR0IvU',
  authDomain: 'feedbot-f5062.firebaseapp.com',
  databaseURL: 'https://feedbot-f5062.firebaseio.com',
  projectId: 'feedbot-f5062',
  storageBucket: 'feedbot-f5062.appspot.com',
  messagingSenderId: '318251928334',
};

export default firebaseDev;



// WEBPACK FOOTER //
// ./src/constants/firebaseDev.js